import { useMemo } from "react";
import { useAppContext } from "../Context/AppContext";
import { isLoggedIn } from "../auth/authStorage";
import { useGetExplorerConnectionLimit } from "../api/queries/useGetExplorerConnectionLimit";
import { useCurrentMembership } from "./useCurrentMembership";

/**
 * Explorer-only weekly connection action budget (send + accept, max 1/week).
 * Paid members always have unlimited actions.
 */
export function useExplorerConnectionLimit() {
  const { objectId } = useAppContext();
  const userId = objectId ?? "";
  const { isExplorer } = useCurrentMembership();

  const { data: limitData, refetch: refetchLimit } = useGetExplorerConnectionLimit({
    userId,
    enabled: isLoggedIn() && !!userId && isExplorer,
  });

  const canPerformConnectionAction = useMemo(() => {
    if (!isExplorer) return true;
    return limitData?.canPerformAction !== false;
  }, [isExplorer, limitData?.canPerformAction]);

  return {
    isExplorer,
    canPerformConnectionAction,
    used: limitData?.used ?? 0,
    limit: limitData?.limit ?? 1,
    remaining: limitData?.remaining ?? 1,
    weekResetsUtc: limitData?.weekResetsUtc,
    refetchLimit,
  };
}
